import { LOGO_URL, CONTACT_EMAIL, scrollToId } from "../constants";
import ContactForm from "./ContactForm";
import { Reveal, FrequencyWave } from "./motion";

const footerLinks = [
  { label: "Soul in Love", path: "/soul-in-love", testId: "footer-link-soul-in-love" },
  { label: "Amber Ellis", path: "/amber-ellis", testId: "footer-link-amber-ellis" },
  { label: "Tundala", path: "/tundala", testId: "footer-link-tundala" },
  { label: "Tonal Intentions", id: "tonal-intentions", testId: "footer-link-tonal-intentions" },
  { label: "About", id: "founder", testId: "footer-link-about" },
];

const FinalCta = () => (
  <div className="theme-dark bg-[#0a0908] text-white">
    <section
      id="contact"
      data-testid="final-cta-section"
      className="relative overflow-hidden py-36 lg:py-44"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="glow-pulse absolute left-1/2 top-1/3 h-[38rem] w-[38rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.12)_0%,transparent_62%)]" />
        <FrequencyWave tone="light" className="absolute bottom-10 left-0 h-32 w-full" opacity={0.4} />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <img
            src={LOGO_URL}
            alt="The SEAL Collective emblem"
            className="mx-auto mb-12 w-24 object-contain opacity-95"
          />
          <h2
            data-testid="final-cta-headline"
            className="font-serif-display text-4xl font-light leading-[1.12] tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            FIND THE FREQUENCY THAT{" "}
            <span className="text-gold-gradient-light">MOVES YOU FORWARD.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <button
              data-testid="final-explore-button"
              onClick={() => scrollToId("the-collective")}
              className="btn-solid"
            >
              Explore the Collective
            </button>
            <button
              data-testid="final-connect-button"
              onClick={() => scrollToId("contact-form-anchor")}
              className="btn-outline"
            >
              Connect with Amber
            </button>
          </div>
        </Reveal>

        <div id="contact-form-anchor" className="mt-24 scroll-mt-28">
          <ContactForm dark />
        </div>
        <p className="mt-10 text-xs font-light tracking-[0.2em] text-white/40">
          <a
            data-testid="final-email-link"
            href={`mailto:${CONTACT_EMAIL}`}
            className="transition-colors duration-500 hover:text-[#f3e5ab]"
          >
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </section>

    <footer data-testid="site-footer" className="border-t hairline-light">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 px-6 py-16 lg:flex-row lg:justify-between lg:px-12">
        <div className="text-center lg:text-left">
          <p data-testid="footer-brand" className="font-serif-display text-lg font-light tracking-[0.3em] text-white">
            THE SEAL COLLECTIVE
          </p>
          <p className="mt-2 text-[0.65rem] font-extralight tracking-[0.25em] text-white/40">
            Voice. Heart. Resonance. Human Transformation.
          </p>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {footerLinks.map((l) =>
            l.path ? (
              <a
                key={l.testId}
                data-testid={l.testId}
                href={l.path}
                className="text-[0.6rem] font-light uppercase tracking-[0.3em] text-white/50 transition-colors duration-500 hover:text-[#f3e5ab]"
              >
                {l.label}
              </a>
            ) : (
              <button
                key={l.testId}
                data-testid={l.testId}
                onClick={() => scrollToId(l.id)}
                className="text-[0.6rem] font-light uppercase tracking-[0.3em] text-white/50 transition-colors duration-500 hover:text-[#f3e5ab]"
              >
                {l.label}
              </button>
            )
          )}
        </nav>
      </div>
      <div className="border-t hairline-light">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-6 py-8 lg:px-12">
          <span className="text-[0.6rem] font-light uppercase tracking-[0.35em] text-white/30">
            Follow the work
          </span>
          {[
            { label: "Instagram", url: "https://www.instagram.com/soul_inlove_/", testId: "social-instagram" },
            { label: "YouTube", url: "https://www.youtube.com/@SoulinloveChannelings", testId: "social-youtube" },
            { label: "TikTok", url: "https://www.tiktok.com/@soulinlove_", testId: "social-tiktok" },
            { label: "Facebook", url: "https://www.facebook.com/profile.php?id=61587527752249", testId: "social-facebook" },
            { label: "soulinlove.com", url: "https://soulinlove.com", testId: "social-soulinlove" },
          ].map((s) => (
            <a
              key={s.testId}
              data-testid={s.testId}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[0.6rem] font-light uppercase tracking-[0.3em] text-white/50 transition-colors duration-500 hover:text-[#f3e5ab]"
            >
              {s.label}
            </a>
          ))}
        </div>
      </div>
      <div className="border-t hairline-light py-6 text-center text-[0.6rem] font-extralight tracking-[0.3em] text-white/25">
        © {new Date().getFullYear()} THE SEAL COLLECTIVE
      </div>
    </footer>
  </div>
);

export default FinalCta;
